import { WorkOrderRequestTypes } from '../ActionTypes/WorkOrderRequestTypes';

class WorkOrderRequestActions {

    static getWorkOrderRequestCustomers = payload => {
        return {
            type: WorkOrderRequestTypes.GET_WORK_ORDER_REQUEST_CUSTOMERS,
            payload: payload,
        };
    };

    static clearWorkOrderRequestCustomers = () => {
        return {
            type: WorkOrderRequestTypes.CLEAR_WORK_ORDER_REQUEST_CUSTOMERS,
        };
    };

    static getWorkOrderRequestList = (payload) => {
        return {
            type: WorkOrderRequestTypes.GET_WORK_ORDER_REQUEST_LIST,
            payload: payload,        };
    };

    static clearWorkOrderRequestList = () => {
        return {
            type: WorkOrderRequestTypes.CLEAR_WORK_ORDER_REQUEST_LIST,
        };
    };

}

export default WorkOrderRequestActions;
